import { trackingEvent } from '@notino/web-tracking';

export const dispatchTrackingEvent = (
  ...event: Parameters<typeof trackingEvent>
) => {
  document.dispatchEvent(trackingEvent(...event));
};
